export const company = "Transpera Technologies";
export const siteName = "Ameena";
export const colorPrimary = "#424874";
export const PhoneNumberRegex = /^(?:\+?\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
export const PostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

